export default __webpack_public_path__ + "static/member2-468fe236e3391ba3c6fcf31ea1e3441e.png";